import React, { useState, useEffect } from 'react';
import { CookieConsent } from '../lib/cookieConsent';

const CookieConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if consent has already been given
    const consent = CookieConsent.hasConsent();

    if (consent === null) {
      // No consent decision yet, show banner after a short delay
      setTimeout(() => {
        setShowBanner(true);
        setTimeout(() => setIsVisible(true), 100); // Animation delay
      }, 1000);
    } else if (consent === true) {
      // User has consented, load GA
      CookieConsent.loadGoogleAnalytics();
    }
  }, []);

  const handleAccept = () => {
    CookieConsent.setConsent(true);
    setIsVisible(false);
    setTimeout(() => setShowBanner(false), 300); // Wait for animation
  };

  const handleDecline = () => {
    CookieConsent.setConsent(false);
    setIsVisible(false);
    setTimeout(() => setShowBanner(false), 300); // Wait for animation
  };

  if (!showBanner) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 p-4 transition-all duration-300 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="max-w-6xl mx-auto">
        <div className="bg-card border-2 border-primary/30 rounded-2xl shadow-2xl p-6 backdrop-blur-lg">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            {/* Content */}
            <div className="flex-1">
              <div className="flex items-start gap-3 mb-3">
                <span className="text-2xl">🍪</span>
                <div>
                  <h3 className="text-lg font-bold text-foreground mb-1">
                    Cookies & Απόρρητο
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Χρησιμοποιούμε cookies για να αναλύσουμε την επισκεψιμότητα με το{' '}
                    <strong>Google Analytics</strong>. Τα δεδομένα σας είναι ανώνυμα και
                    χρησιμοποιούνται μόνο για βελτίωση της εμπειρίας σας. Μπορείτε να
                    αποδεχτείτε ή να απορρίψετε τη χρήση cookies.
                  </p>
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
              <button
                onClick={handleDecline}
                className="px-6 py-2.5 rounded-lg border-2 border-border bg-muted text-foreground font-semibold hover:bg-muted/80 transition-colors text-sm whitespace-nowrap"
              >
                Απόρριψη
              </button>
              <button
                onClick={handleAccept}
                className="px-6 py-2.5 rounded-lg bg-primary text-primary-foreground font-semibold hover:bg-primary/90 transition-colors shadow-lg text-sm whitespace-nowrap"
              >
                Αποδοχή Cookies ✓
              </button>
            </div>
          </div>

          {/* Privacy Link */}
          <div className="mt-3 pt-3 border-t border-border">
            <p className="text-xs text-muted-foreground text-center md:text-left">
              Με την αποδοχή, συμφωνείτε με τη χρήση του Google Analytics για στατιστικούς σκοπούς.
              Μπορείτε να αλλάξετε τις προτιμήσεις σας ανά πάσα στιγμή.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;

